import { Component, OnInit, ElementRef, Output, EventEmitter, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'company-contact-actions',
  templateUrl: './contact-actions.component.html',
  styleUrls: ['./contact-actions.component.scss']
})
export class CompanyContactActionsComponent implements OnInit {
  @ViewChild('inputSearchContact', { static: true }) inputSearchContact: ElementRef;
  @Output() contactsOrientationEmit: EventEmitter<string> = new EventEmitter();
  @Output() searchContactEmit: EventEmitter<string> = new EventEmitter();
  @Output() contactFormatEmit: EventEmitter<string> = new EventEmitter();
  @Input() searchContact: string;

  private contactFormat: string = 'person';
  private selectedOrientation: string = "details";


  constructor() { }

  ngOnInit() {
    this.contactFormatEmit.emit(this.contactFormat);
  }

  // private onSearch(search: string):void {
  //   if ( search.length > 0 ) {
  //     console.log(search);
  //   } else {
  //     console.log('nothing');
  //   }
  // }

  // public onKeypress(e) {
  //   if ( e.keyCode === 13 || e.charCode === 13 || e.key === "Enter") {
  //     const query = this.inputSearchContact.nativeElement.value;

  //     this.onSearch(query);
  //   }
  // }

  public changeOrientation( type: string, contactFormat: string = '' ) {
    if ( type === 'details' ) {
      this.selectedOrientation = 'listview';

      if ( contactFormat === 'person' )
        this.contactsOrientationEmit.emit('listview-person');

      else if ( contactFormat === 'institution')
        this.contactsOrientationEmit.emit('listview-institution');

    } else if ( type === 'listview' ) {
      this.selectedOrientation = 'details'
      this.contactsOrientationEmit.emit('details');

    } 
  }

  public updateFilter(event) {
    const val = event.target.value.toLowerCase();

    this.searchContactEmit.emit(val);    
  }

  public changeDataFormat ( contactFormat: string ) {
    this.searchContact = ''
    this.contactFormat = contactFormat;
    this.contactFormatEmit.emit(this.contactFormat);

    this.changeOrientation('listview', contactFormat);
  }
}

